import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorGlobalJiraRoute: InvariantJiraRoute = {
	name: 'global-issue-navigator',
	path: '/jira/issues/:issueKey?',
	query: ['filter?'],
};
